// src/context/AuthContext.js (or wherever it's located)

import { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [role, setRole] = useState(null);
  const [adminId, setAdminId] = useState(null); // 1. Add state for adminId

  // 2. Update the login function to accept the full data object
  const login = (authData) => {
    const { token, admin_id } = authData;

    // Store both token and admin_id in localStorage for persistence
    localStorage.setItem("adminToken", token);
    localStorage.setItem("adminId", admin_id); // NEW

    try {
      const decoded = jwtDecode(token);
      setRole(decoded.role || "operator");
      setAdminId(admin_id); // NEW: Set the adminId state
      setIsLoggedIn(true);
    } catch (err) {
      console.error("Invalid token", err);
      logout();
    }
  };

  const logout = () => {
    // 3. Clear adminId on logout
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminId"); // NEW
    setIsLoggedIn(false);
    setRole(null);
    setAdminId(null); // NEW
  };

  useEffect(() => {
    // 4. Rehydrate state from localStorage on initial load
    const token = localStorage.getItem("adminToken");
    const storedAdminId = localStorage.getItem("adminId"); // NEW

    if (token && storedAdminId) {
      // Check for both
      try {
        const decoded = jwtDecode(token);
        const now = Date.now() / 1000;

        if (decoded.exp && decoded.exp > now) {
          setIsLoggedIn(true);
          setRole(decoded.role || "operator");
          setAdminId(storedAdminId); // NEW: Rehydrate adminId
        } else {
          // Token expired
          logout();
        }
      } catch (err) {
        // Invalid token
        logout();
      }
    }
  }, []);

  return (
    <AuthContext.Provider value={{ isLoggedIn, role, adminId, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
